import type { AgentChatListItem } from '@/api/client';

export const MESSENGER_PINNED_AGENT_CHATS_STORAGE_KEY = 'messenger.pinnedAgentChats.v1';

export function readMessengerPinnedAgentChatIds(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(MESSENGER_PINNED_AGENT_CHATS_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id): id is string => typeof id === 'string');
  } catch {
    return [];
  }
}

export function writeMessengerPinnedAgentChatIds(ids: string[]): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(MESSENGER_PINNED_AGENT_CHATS_STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // localStorage может быть недоступен
  }
}

function agentChatListActivityMs(c: AgentChatListItem): number {
  const raw = c.last_message_at ?? c.created_at;
  const ms = new Date(raw).getTime();
  return Number.isFinite(ms) ? ms : 0;
}

function compareAgentChatsByActivityDesc(a: AgentChatListItem, b: AgentChatListItem): number {
  const diff = agentChatListActivityMs(b) - agentChatListActivityMs(a);
  if (diff !== 0) return diff;
  return b.id.localeCompare(a.id);
}

/** Закреплённые чаты сверху (в порядке закрепления), остальные — по активности. */
export function orderAgentChatsForSidebar(
  chats: AgentChatListItem[],
  pinnedIds: readonly string[]
): AgentChatListItem[] {
  const byId = new Map(chats.map((c) => [c.id, c]));
  const pinned: AgentChatListItem[] = [];
  for (const id of pinnedIds) {
    const chat = byId.get(id);
    if (chat) pinned.push(chat);
  }
  const pinSet = new Set(pinnedIds);
  const unpinned = chats.filter((c) => !pinSet.has(c.id));
  unpinned.sort(compareAgentChatsByActivityDesc);
  return [...pinned, ...unpinned];
}
